import styled from 'styled-components';
import { Container } from '../../styles/Common';

const MarketingExperts = () => {
  return (
    <MainWrapper>
      <Container>
        <Wrapper>
          <Left>
            <img
              src="/assets/images/homepage-marketing-experts-section-image.png"
              alt="marketing-img"
            />
          </Left>
          <Right>
            <h2>The industry leaders: We take the stress off you.</h2>
            <p>
              Entrepreneurs only have so much time in the day. Don't waste it
              trying to learn new skills & figuring out what works. Smart
              business owners delegate emails to the top dog agency for
              e-commerce, dropshipping & digital products.
            </p>
            <ProgressWrapper>
              <SingleProgress>
                <h3>100%</h3>
                <p>
                  We have 100% of client <br />
                  satisfaction level
                </p>
              </SingleProgress>
              <SingleProgress>
                <h3>250%</h3>
                <p>
                  We have massive growth <br />
                  rate of 250%
                </p>
              </SingleProgress>
              <SingleProgress>
                <h3>No.1</h3>
                <p>
                  We are no.1 marketing <br />
                  Agency company
                </p>
              </SingleProgress>
            </ProgressWrapper>
          </Right>
        </Wrapper>
      </Container>
    </MainWrapper>
  );
};

export default MarketingExperts;

const MainWrapper = styled.div`
  padding: 190px 0;

  @media (max-width: 1024px) {
    padding: 40px 0;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;

  @media (max-width: 1024px) {
    flex-direction: column;
  }
`;

const Left = styled.div`
  border-radius: 15px;
  width: 42%;
  height: 485px;
  overflow: hidden;

  @media (max-width: 1024px) {
    width: 100%;
    height: 300px;
    margin-bottom: 30px;
  }

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const Right = styled.div`
  width: 52%;

  @media (max-width: 1024px) {
    width: 100%;
  }

  h2 {
    font-weight: 700;
    font-family: font-bold;
    font-size: 45px;
    background: linear-gradient(90deg, #5ca6ed 0%, #b475f8 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
    line-height: 1.5;
    margin-bottom: 20px;
    text-align: left;

    @media (max-width: 1024px) {
      font-size: 32px;
      text-align: center;
    }
  }

  p {
    font-family: font-medium;
    font-weight: 500;
    font-size: 18px;
    color: #989fb3;
    margin-bottom: 30px;
    max-width: 612px;
    line-height: 1.8;
    @media (max-width: 1024px) {
      max-width: 100%;
      text-align: center;
    }
  }
`;

const ProgressWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
`;

const SingleProgress = styled.div`
  width: calc(100% / 3);

  @media (max-width: 576px) {
    width: 47%;
  }

  h3 {
    font-weight: 700;
    font-family: font-bold;
    font-size: 30px;
    color: #5DA5ED;
    margin-bottom: 10px;
    text-align: left;
    @media (max-width: 576px) {
      text-align: center;
    }
  }

  p {
    font-weight: 500;
    font-family: font-medium;
    font-size: 16px;
    color: #989fb2;
    line-height: 1.7;
  }
`;
